<template>
  <div>
    <v-container>
      <!-- Header -->
      <v-row align="center">
        <v-col cols="3">
          <base-title no-margin-top>Scheduler</base-title>
        </v-col>
        <!-- Start -->
        <v-col
          cols="1"
          offset="3"
          class="text-right text-caption primary--text"
        >
          Start: 
        </v-col>
        <v-col cols="2">
          <base-date-picker
            v-model="startDate"
            :allowed-dates="isMondayDate"
          ></base-date-picker>
        </v-col>
        <!-- End -->
        <v-col
          cols="1"
          class="text-right text-caption primary--text"
        >
          End: 
        </v-col>
        <v-col cols="2">
          <base-date-picker
            v-model="endDate"
            :allowed-dates="isFridayDate"
          ></base-date-picker>
        </v-col>
      </v-row>

      <!-- Sub header -->
      <v-row align="center">
        <v-col cols="10">
          <!-- tab header -->
          <!-- <v-tabs height="40" v-model="tabItem" class="" v-if="false">
            <v-tab class="text-none" active-class="font-weight-bold">Doctor</v-tab>
            <v-tab class="text-none" active-class="font-weight-bold">TMA</v-tab>
          </v-tabs> -->
        </v-col>
        <v-col
          cols="2"
          class="d-flex"
        >
          <base-popup-btn
            v-if="is_supervisor"
            class="ml-auto"
            @click="addGroupDialog = true"
          >
            New
          </base-popup-btn>
        </v-col>
      </v-row>
      
      <!-- schedule table -->
      <schedule-table
        :tab-item="tabItem"
        :start="startDate"
      >
      </schedule-table>
    </v-container>

    <!-- DIALOGS -->

    <!-- Add Group -->
    <v-dialog
      v-model="addGroupDialog"
      max-width="450px"
    >
      <v-card rounded="lg" class="pa-3">
        <v-card-title class="d-flex">
          <span class="primary--text">Add Group</span>
          <v-btn
            icon
            class="ml-auto"
            @click="addGroupDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            class="centered-input"
            placeholder="Group Name"
          ></v-text-field>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            depressed
            rounded
            color="primary"
            width="100px"
            class="text-none font-weight-regular mx-5"
            @click="saveAddGroup"
          >
            Save
          </v-btn>

          <v-btn
            depressed
            rounded
            color="blue lighten-4 primary--text"
            width="100px"
            class="text-none font-weight-regular mx-5"
            @click="addGroupDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import moment from "moment"
  export default {
    name:'Scheduler',

    components: {
      ScheduleTable: () => import('./components/ScheduleTable.vue')
    },

    watch: {
      start(val) {
        console.log('start', val)
      },
      startDate(val) { 
        var sunday = moment(val).add(6, 'days').format('YYYY-MM-DD')
        this.endDate = sunday 
      },
      endDate(val) { 
        var monday = moment(val).add(-6, 'days').format('YYYY-MM-DD')
        this.startDate = monday          
      },
    },

    computed: {
      is_supervisor(){
        return this.$store.getters['profile/profile']?.is_supervisor
      }
    },

    data: ()=>({
      date: '',
      type: '',
      start: null,
      end: null,
      menu: false,
      menu2: false,
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      tabItem: 1,
      // Add Group
      addGroupDialog: false,
      isSavingAddGroup: false,
    }),

    mounted() {
        console.log('profile: ', this.is_supervisor)
    },

    methods: {
      isMondayDate(val) { 
        // console.log(moment(val).weekday())
        return moment(val).weekday() == 1
        // return parseInt(val.split('-')[2], 10) % 2 === 0
      },
      isFridayDate(val) {
        return moment(val).weekday() == 0
      },
      saveAddGroup() {
        this.isSavingAddGroup = true
        this.isSavingAddGroup = false
      },
    }
  }
</script>

<style lang="scss">
  .centered-input input {
    text-align: center
  }
</style>